import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, Polygon,Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "150%",
  height: "400px",
};

const center = {
  lat: 0,
  lng: 0,
};

const GmapMultiple = (prop) => {
  const [path, setPath] = useState([]);

  const [pathLocation, setPathLocation] = useState();
  const [marketCoordinate, SetMarketCoordinate] = useState([]);
  const [plotCoordinateList, setPlotCoordinateList] = useState([]);
  const [optionsGreen, setOptionsGreen] = useState({
    strokeWeight: 3.0,
    fillColor: "Green",
  });

  
  const [optionsRed, setOptionsRed] = useState({
    strokeWeight: 2.0,
    fillColor: "Red",
  });
  const [optionsCyan, setOptionsCyan] = useState({
    strokeWeight: 2.0,
    fillColor: "Cyan",
  });
  const [optionsffbf00, setOptionsffbf00] = useState({
    strokeWeight: 2.0,
    fillColor: "#ffbf00",
  });

  const [mapZoom, setMapZoom] = useState(15);

  useEffect(() => {
    console.log(prop);

    if (prop.coordinate) {
      //console.log("prop",prop);
      var temppath = prop.coordinate;
      console.log("temppath",temppath);
      setPath([...temppath]);
      //console.log("temppath",temppath[0]);

      // setPathLocation({lat:19.526954,lng:74.207002})
      setPathLocation(temppath[0]);

      SetMarketCoordinate(prop.marketCoordinate);
      console.log("prop.plotCoordinateList",prop.plotCoordinateList);
      setPlotCoordinateList(prop.plotCoordinateList);
      setMapZoom(prop.mapzoom);
      console.log("prop.mapzoom", prop.mapzoom);
    }
  }, [prop.coordinate]);

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyABE5oLDQJp-iEBTdd1QdTi0J8io3ufq6o"
      id="script-loader"
      language="en"
      region="us"
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        mapContainerClassName="App-map"
        center={pathLocation}
        zoom={mapZoom}
        mapTypeId="satellite"
        fillColor="#00FF00"
         
      >
        {plotCoordinateList.map(({ plotCorodinate, colorCode, id }) => (
           
          <Polygon ket={id}
            path={plotCorodinate}
            options={
              colorCode == "Red"
                ? optionsRed
                : colorCode == "Green"
                ? optionsGreen
                : colorCode == "Cyan"
                ? optionsCyan
                : optionsffbf00
            }
          />
        ))}


{marketCoordinate.map(({ lat,lng,tittleName,id }) => (
        
        <Marker position={{lat: lat, lng: lng}}  
        tittle={tittleName}

        key={id}
        />
        ))} 
      </GoogleMap>
    </LoadScript>
  );
};

export default GmapMultiple;
